import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { buildCmsMeta, renderCmsArticleHtml } from '../utils/cmsArticleHtml';
import './CmsArticle.css';

// Renders a post synced from the shared MeltPlan CMS. The same HTML is prerendered
// into build/blog/<slug>.html by scripts/prerender-blog.js for crawlers.
const CmsArticle = ({ post }) => {
  const navigate = useNavigate();
  const meta = buildCmsMeta(post);

  // Keep same-site links inside the SPA instead of full page loads.
  const handleClick = useCallback((e) => {
    const link = e.target.closest('a');
    if (!link || link.target === '_blank' || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    const href = link.getAttribute('href');
    if (href && href.startsWith('/')) {
      e.preventDefault();
      navigate(href);
      window.scrollTo(0, 0);
    }
  }, [navigate]);

  return (
    <>
      <Helmet>
        <title>{meta.title}</title>
        <meta name="description" content={meta.description} />
        <link rel="canonical" href={meta.canonical} />
        {meta.tags.map(([attr, key, content]) => (
          <meta key={key} {...{ [attr]: key }} content={content} />
        ))}
        {meta.jsonLd.map((obj) => (
          <script key={obj['@type']} type="application/ld+json">{JSON.stringify(obj)}</script>
        ))}
      </Helmet>
      {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */}
      <div onClick={handleClick} dangerouslySetInnerHTML={{ __html: renderCmsArticleHtml(post) }} />
    </>
  );
};

export default CmsArticle;
